<template>
  <el-form class="form form__contact" @submit.native.prevent="onSubmit()" :disabled="!isOnline">

    <messages :messages="messages" :request="request"/>

    <input type="hidden" v-model="fname"/>

    <input-email-field
      id="email"
      :label="$t('contactEmailLabel')"
      :disabled="!isOnline"
      v-model="fromEmail"
    />

    <input-field
      id="subject"
      type="text"
      :label="$t('contactSubjectLabel')"
      :disabled="!isOnline"
      v-model="subject"
    />

    <input-field
      id="message"
      type="textarea"
      :label="$t('contactMessageLabel')"
      :disabled="!isOnline"
      v-model="message"
    />

    <el-form-item>
      <el-button
        type="primary"
        native-type="submit"
        v-loading="sending"
        :disabled="!readyToSubmit"
      >
        {{ $t('contactSendLabel') }}
      </el-button>
    </el-form-item>

  </el-form>
</template>

<script>
  import {mapState} from 'vuex';
  import user from '@/components/user';
  import offline from '@/offline';
  import i18n from '@/configured/vue-i18n/i18n';
  import api, {csrfRequest, jsonToMultiPartFormData, craftError} from '@/api';
  import Messages from '@/components/Messages';
  import InputField from '@/components/inputs/InputField';
  import InputEmailField from '@/components/inputs/InputEmailField';
  import log from '@/configured/logger';

  export default {
    name: 'ContactForm',
    data() {
      return {
        fname: '', // This is the honeypot field
        fromEmail: '',
        subject: '',
        message: '',

        messages: [],
        request: null,
        sending: false,
      }
    },
    components: {
      InputField,
      InputEmailField,
      Messages,
    },
    computed: {
      ...mapState(user.store.namespace, [
        'currentUser'
      ]),
      ...mapState(offline.store.namespace, [
        'isOnline'
      ]),
      readyToSubmit,
    },
    methods: {
      onSubmit,
      handleSuccess,
      handleError,
      initSend,
    },
    beforeMount() {
      this.fromEmail = this.currentUser ? this.currentUser.email : '';
    }
  }

  /////////////////

  function readyToSubmit() {
    if (!this.isOnline) {
      return false;
    }

    if (this.sending) {
      return false;
    }

    if (!this.fromEmail || this.fromEmail.length < 5) {
      return false;
    }

    if (!this.subject || this.subject.length === 0) {
      return false;
    }

    if (!this.message || this.message.length === 0) {
      return false;
    }

    if (this.fname && this.fname.length > 0) {
      return false;
    }

    return true;
  }

  function onSubmit() {
    this.initSend();
    this.request = new Promise((resolve, reject) => {
        csrfRequest().then(csrf => {
            let data = {
              fromEmail: this.fromEmail,
              subject: this.subject,
              message: this.message,
              fname: this.fname,
            }
            data[csrf.name] = csrf.value;
            api.post('/api/contact', jsonToMultiPartFormData(data))
              .then(rsp => {
                this.sending = false;
                if (craftError(rsp)) {
                  this.handleError(rsp);
                  return reject(rsp);
                }
                this.handleSuccess();
                resolve(rsp);
              })
              .catch(rsp => {
                this.sending = false;
                this.handleError(rsp);
                return reject(rsp);
              })
        });
    });
  }

  function initSend() {
    this.sending = true;
    if (this.messages) {
      this.messages.splice(0, this.messages.length);
    } else {
      this.messages = [];
    }
  }

  function handleError(rsp) {
    log.error('Error submitting form', rsp);
    this.messages.push({
      text: i18n.t('contactErrorMessage'),
      type: 'error',
      id: +new Date(),
    });
  }

  function handleSuccess() {
    log.info('success');
    this.subject = '';
    this.message = '';
    // The success message will be handled by the Messages component from the Contact Form plugin response
  }
</script>
